import { render, staticRenderFns } from "./subjectTeacher.vue?vue&type=template&id=b2942ec6&scoped=true"
import script from "./subjectTeacher.vue?vue&type=script&lang=js"
export * from "./subjectTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2942ec6",
  null
  
)

export default component.exports